import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { ImportProMappedHeadersProfile } from 'src/app/shared/models/import-pro-mapped-headers-profile';
import { PartnerGroup } from 'src/app/shared/models/partner-group';
import { PartnerPro } from 'src/app/shared/models/partner-pro';
import { Show } from 'src/app/shared/models/show';
import { PROShow } from 'src/app/shared/models/proshow';
import { ImportService } from 'src/app/shared/services/import.service';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { MatSelectBottomScrollDirective } from 'src/app/shared/data_components/_directives/mat-select-bottom-scroll.directive';
import { PartnerGroupMember } from 'src/app/shared/models/partner-group-member';
import { Episode } from 'src/app/shared/models/episode';
import { Season } from 'src/app/shared/models/season';
import { EpisodeMapperModalComponent } from '../../_modals/episode-mapper-modal/episode-mapper-modal.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShowMapperProfile } from 'src/app/shared/models/show-mapper-profile';
import { PartnerGroupMappedShow } from 'src/app/shared/models/partner-group-mapped-show';
import { DataManagementCreateShowModalComponent } from '../../_modals/data-management-create-show-modal/data-management-create-show-modal.component';


@Component({
  selector: 'app-partner-group-show-mapper',
  templateUrl: './partner-group-show-mapper.component.html',
  styleUrls: ['./partner-group-show-mapper.component.scss']
})
export class PartnerGroupShowMapperComponent implements OnInit {

  // //used for triggering scroll event
  // @ViewChild('selectRef') selectRef!: MatSelect;

  //optional paramater 
  profileId = null;

  partnerGroups: PartnerGroup[] = [];
  allShows: Show[] = [];
  // allShows: PROShow[] = [];

  importProMappedHeadersProfile: ImportProMappedHeadersProfile = new ImportProMappedHeadersProfile();

  //represents all PartnerPro objects created from the header mapping process
  // allPartnerPros: PartnerPro[] = []
  allPartnerPros: any;

  //this is the fitered down list by distinct shows (unrecognized shows placed at front of list)
  // filteredPartnerPros: PartnerPro[] = [];
  filteredPartnerPros: any;


  //represents the mapped objects displayed in the UI
  mappedPartnerPros: any;

  //used for shows pagination
  moreShowsUrl = '';

  //this will represent the episodes pulled from the import PRO
  //they will be grouped by show name
  showsAndEpisodes: any[] = [];

  //used to for unrecognized episode names which have already been mapped
  mappedEpisodes: any[] = [];


  //used to track changes on the show mapper view
  //this will allow the user to save their progress
  //and come back to complete later
  showMapperProfile: ShowMapperProfile = new ShowMapperProfile();

  // NEW PRO DATA BELOW
  ProShows: any;
  allShowsCount: number;

  // pagination tools
  length;
  currentPage = 0;
  pageSize;

  // END

  // search tools
  searchFilterFocused = false;
  keyValue;
  isSearchingShows = false;
  isLoadingInitialShows = false;
  // END


  constructor(private partnerService: PartnerService, private importService: ImportService, private route: ActivatedRoute, private snackbarService: SnackBarService, public dialog: MatDialog, private cdr: ChangeDetectorRef) { }

  ngOnInit() {


    this.partnerService.getAllPROShows().subscribe((res: any) => {
      this.ProShows = res;
    });

    // reload shows when Add New Show modal closes
    this.partnerService.modalClosed$.subscribe(() => {
      this.partnerService.getAllPROShows().subscribe((res: any) => {
        this.ProShows = res;
      });
    });

    this.importService.setBreadCrumbActiveStep(2);

    //checks to see if a profileId was passed, otherwise it will use the profile stored in the service file
    this.route.queryParams.subscribe(params => {
      this.profileId = params['profileId'];
      console.log('Profile ID:', this.profileId);

      if (this.profileId) {
        this.importService.getImportProMappedHeadersProfile(this.profileId).subscribe((x) => {
          this.importService.setImportProMappedHeadersProfile(x);

          //this needs to be set for the header to display the appropriate buttons
          this.importService.setImportedFilePath(x.filePath);

        })
      }
    });


    //track ImportProMappedHeadersProfile then get data from imported spread sheet
    this.importService.importProMappedHeadersProfile$.subscribe((x) => {
      this.importProMappedHeadersProfile = x;
      this.isLoadingInitialShows = true;

      //set import details for show mapper profile - used for saving progress
      this.showMapperProfile.partnerProImportDetails = x;

      // note: '1' loads first page from server
      this.importService.getImportDetails(this.importProMappedHeadersProfile.id, 1).subscribe((resPartnerPros: any) => {
        this.allPartnerPros = resPartnerPros.results;
        this.allShowsCount = resPartnerPros.count;

        //extract episodes from imported data
        this.extractEpisodes();

        // Order by partnerPro.show.id ascending
        // const orderedPartnerPros = resPartnerPros.sort((a, b) => a.show.id - b.show.id);

        const orderedPartnerPros = resPartnerPros.results.sort((a, b) => {
          if (a.show === null && b.show !== null) {
            return -1; // Place `a` before `b`
          } else if (a.show !== null && b.show === null) {
            return 1; // Place `b` before `a`
          } else if (a.show === null && b.show === null) {
            // Both are null, sort by `unrecognizedShow`
            return (a.unrecognizedShow || '').localeCompare(b.unrecognizedShow || '');
          } else {
            // Both are not null, sort by `show.id`
            return a.show.id - b.show.id;
          }
        });

        //track all shows
        this.partnerService.allShows$.subscribe((x) => {
          this.allShows = x;


          // //filter down to distinct values - place unrecognized show names at the top
          // const distinctNames = new Set();
          // this.filteredPartnerPros = orderedPartnerPros.filter(partnerPro => {
          //   if (!distinctNames.has(partnerPro.show.name)) {
          //     distinctNames.add(partnerPro.show.name);
          //     return true;
          //   }
          //   return false;
          // }).sort((a, b) => {
          //   const aInAllShows = this.allShows.some(item => item.name === a.show.name);
          //   const bInAllShows = this.allShows.some(item => item.name === b.show.name);

          //   if (aInAllShows && !bInAllShows) {
          //     return 1;  // a should come after b
          //   } else if (!aInAllShows && bInAllShows) {
          //     return -1; // a should come before b
          //   }
          //   return 0;    // no change in order
          // });

          const distinctValues = new Set();
          this.filteredPartnerPros = orderedPartnerPros.filter(partnerPro => {
            // valueToCheck ???
            // partnerPro.show & show.name are always returning as null?
            // const valueToCheck = partnerPro.show ? partnerPro.show.name : partnerPro.unrecognizedShow;
            // const valueToCheck = partnerPro.showName ? partnerPro.showName : partnerPro.unrecognizedShow;
            const valueToCheck = partnerPro.showName;

            if (!distinctValues.has(valueToCheck)) {
              distinctValues.add(valueToCheck);
              return true;
            }
            return false;
          }).sort((a, b) => {
            const aInAllShows = this.allShows.some(item => item.name === (a.show ? a.show.name : a.unrecognizedShow));
            const bInAllShows = this.allShows.some(item => item.name === (b.show ? b.show.name : b.unrecognizedShow));

            if (aInAllShows && !bInAllShows) {
              return 1;  // a should come after b
            } else if (!aInAllShows && bInAllShows) {
              return -1; // a should come before b
            }

            // If both are either in or not in allShows, maintain their order
            return 0;
          });


          this.importService.setMappedParterPros(this.filteredPartnerPros);

        });

        // //build the list for this display
        // //this will have dynamic properties set from the html file
        // this.mappedPartnerPros = this.filteredPartnerPros;

        this.isLoadingInitialShows = false;
      })
    });


    //track mapped partner pros
    this.importService.mappedPartnerPros$.subscribe((x) => {
      this.mappedPartnerPros = x;

      this.mapRecognizedShowsToGroups();
    })

    //pull in show values
    this.resetShows();



    //pull in partner groups
    this.partnerService.getPartnerGroups().subscribe((resPartnerGroups: any) => {
      this.partnerService.setPartnerGroups(resPartnerGroups.results);
    });

    //track partner groups
    this.partnerService.partnerGroups$.subscribe((x) => {
      this.partnerGroups = x;

      this.mapRecognizedShowsToGroups();

    });

    //track next url for shows pagination
    this.partnerService.moreShowsUrl$.subscribe((x) => {
      this.moreShowsUrl = x;
    });


  }

  /**
   * This function pulls all of the episode names from the imported PRO
   * and groups them with the show names
   */
  extractEpisodes() {

    //reset
    this.showsAndEpisodes = [];

    this.allPartnerPros.forEach(pro => {

      //pull all rows for show name
      let allRowsForShow = this.allPartnerPros.filter(row => row.unrecognizedShow == pro.unrecognizedShow && row.mapToShow?.id == pro.mapToShow?.id);

      //only proceed if we have not already added the data for this show name
      if (!this.showsAndEpisodes.includes(item => item.name == pro.unrecognizedShow || item.name == pro.mapToShow.name)) {

        //start by pulling episodes for RECOGNIZED Show names
        if (pro.mapToShow) {

          //the show is recognized, use the show.name from this object
          const show = {
            name: pro.mapToShow.name,
            episodes: allRowsForShow.map(show => show.episodeName)
          };

          //add to the list of shows and episodes
          console.log(show);
          this.showsAndEpisodes.push(show);
        }
        //next, pull episodes for UNRECOGNIZED show names
        else if (pro.unrecognizedShow) {
          const show = {
            name: pro.unrecognizedShow,
            episodes: allRowsForShow.map(show => show.episodeName)
          };

          //add to the list of shows and episodes
          this.showsAndEpisodes.push(show);
        }
      }

    })
  }


  /**
   * Once this.partnerPros and this.mappedPartnerPros are set
   * This will pre map any recognized shows to their associated groups
   */
  mapRecognizedShowsToGroups() {
    //ensure both list are populated before pre-mapping
    if (this.mappedPartnerPros.length > 0 && this.partnerGroups.length > 0) {
      this.mappedPartnerPros.forEach(pro => {
        if (pro.mapToShow) {
          //we have a recognized show / set the pro.selectedGroup value
          console.log(pro.mapToShow);
          pro.selectedGroups.push(this.partnerGroups.find(group => group.id == pro.mapToShow.partnerGroup.id))
        }
      })
    }
  }

  // ngAfterViewInit() {
  //   // Use a setTimeout to ensure the view has been initialized
  //   setTimeout(() => {
  //     const dropdownElement = this.selectRef.panel.nativeElement;
  //     dropdownElement.addEventListener('scroll', event => this.onScroll(event));
  //   });
  // }

  // onScroll(event: Event) {
  //   const target = event.target as HTMLElement;
  //   if (target.scrollHeight - target.scrollTop === target.clientHeight) {
  //     // Scrolled to the bottom
  //     this.loadMoreShows(); // Replace with your function
  //   }
  // }

  /**
   * Loads next page of shows
   */
  loadMoreShows() {

    this.partnerService.getAllShows(this.moreShowsUrl, 'name', undefined).subscribe(resShows => {
      //concat to existing list
      this.allShows = this.allShows.concat(resShows);

      console.log(`Shows count ${this.allShows.length}`);

      this.partnerService.setAllShows(this.allShows);
    })
  }

  /**
   * Pull page 1 of all shows
   */
  resetShows() {
    //pull in show values
    this.partnerService.getAllShows(undefined, 'name', undefined).subscribe(resAllShows => {
      this.partnerService.setAllShows(resAllShows);
    });
  }


  /**
   * Searches the shows by name
   * @param search 
   */
  searchShows(search: string) {
    this.partnerService.getAllShows(undefined, 'name', search).subscribe(resAllShows => {
      this.partnerService.setAllShows(resAllShows);
    })
  }

  onShowSelected(event: any, pro: PartnerPro) {
    pro.mapToShow = event.option.value;
  }

  //determines if the show name is recognized or not
  isRecognizedShowName(showName: string, index: number | null = null): boolean {
    const isRecognized = this.allShows.some(show => show.name.toLowerCase() === showName.toLowerCase());

    //if index is null, we can skip this step.  
    //this will be completed as soon as the user selects a show
    if (isRecognized && index) {
      //we need to set up the seasons and episodes select box




    }

    return isRecognized;
  }


  /**
   * Ensure partnerGroup and show is selected
   * @param event 
   * @param header 
   * @param index 
   */
  assignMapping(event: MatCheckboxChange, partnerPro: any, index: number) {


    if ((partnerPro.mapToShow && partnerPro.selectedGroups.length > 0) ||
      (this.isRecognizedShowName(partnerPro.mapToShow.name) && partnerPro.selectedGroups.length > 0)) {
      //either the show was already recognized or a recognized show name was selected, and a partner group has been selected
      if (this.mappedPartnerPros[index].isMapped == true) {
        this.mappedPartnerPros[index].isMapped = false;

        this.snackbarService.showSnackBarMessage("Show and Partner Group Un-Mapped!", 'Close');

      }
      else {
        this.mappedPartnerPros[index].isMapped = true;

        this.snackbarService.showSnackBarMessage("Show and Partner Group Mapped!", 'Close');

      }
    }

    //refresh global variable
    this.importService.setMappedParterPros(this.mappedPartnerPros);
  }

  trackById(_: number, item: any) {
    return item.id;
  }

  /**
   * Unselects the check box if the partner group is changed after being assigned
   * @param part 
   */
  unassignMapping(index: number) {
    this.mappedPartnerPros[index].isMapped = false;
  }

  /**
   * This is used to determine if a new partner group select input
   * field should be displayed for the row
   * @param groups 
   * @returns 
   */
  getSelectedGroupsLengthForPro(groups: PartnerGroup[]): any[] {
    return new Array(groups.length + 1);
  }


  onSeasonChange(event: MatCheckboxChange, season: any, group: PartnerGroup, pro: PartnerPro) {
    // Update state based on season selection
    season.selected = event.checked; //using checkbox value instead here
    // season.selected = !season.selected;
    season.episodes.forEach(episode => {

      //this variable is assigned and used to make sure we are not
      //selecting episodes which were not included as part of the
      //import sheet

      outerLoop: // call break outerLoop; if needed
      for (const item of this.showsAndEpisodes) {
        //here, we will check if the episode is one that has been extracted
        //from the import sheet.  We'll first compare the name, if we don't
        //find it from that, we'll then check the mapped episodes

        let isExtractedEpisode = false;


        // Iterate through each episode in the current item
        for (const episodeStr of item.episodes) {

          if (episodeStr == episode.name) {
            isExtractedEpisode = true;

            break;
          }
          else {
            // Check if there are any mapped episodes for the current season
            if (this.mappedEpisodes.some(mappedEp => mappedEp.episode.season_id === season.id)) {
              // Filter mapped episodes by season ID
              const mappedEpisodes = this.mappedEpisodes.filter(mappedEp => mappedEp.episode.season_id === season.id);

              // Check if any of the mapped episodes match the current episode
              isExtractedEpisode = mappedEpisodes.some(ep => ep.mapped_from === episodeStr && ep.episode.id == episode.id && ep.season_id == episode.season_id);

              // Exit the inner loop once boolean value is determined
              if (isExtractedEpisode)
                break;
            }
          }

        }

        // Exit the outer loop if a match was found
        // if (isExtractedEpisode) {
        //   break;
        // }
        if (isExtractedEpisode) {
          episode.selected = season.selected;

          if (episode.selected) {
            // Add episode to the list if selected

            if (!group.episodes.some(ep => ep == episode)) {
              //avoid adding it twice

              //now check and make sure this episode was part of the data row for the unrecognized show name
              //set to true - we'll change this is the episode does not apply to this data row
              let addEpisode = true;

              if (pro.unrecognizedShow) {
                let eps = this.getEpisodesForSeason(pro, season, group);

                if (!eps.some(ep => ep.name == episode.name)) {
                  //this episode isn't included int his list, don't add it

                  addEpisode = false;
                }

              }

              if (addEpisode) {
                //all checks should be complete, go ahead and add the episode to the group's list

                group.episodes.push(episode)

                group.selectedEpisodesCount++;
              }

            }
          }
          else {
            // Remove episode from the list if not selected
            const index = group.episodes.indexOf(episode);
            if (index > -1) {
              group.episodes.splice(index, 1);

              group.selectedEpisodesCount--;
            }
          }
        }
      }


    });
  }

  onEpisodeChange(event: MouseEvent, episode: Episode, group: PartnerGroup) {

    event.preventDefault();  // Prevent the mat-select from closing
    event.stopPropagation(); // Stop the click event from propagating

    // Update state based on episode selection
    episode.selected = !episode.selected;

    if (episode.selected) {
      // Add episode to the list if selected

      if (!group.episodes.some(ep => ep.id == episode.id)) {
        //avoid adding it twice
        group.episodes.push(episode)

        group.selectedEpisodesCount++;
      }

    }
    else {
      // Remove episode from the list if not selected
      const index = group.episodes.findIndex(ep => ep.id == episode.id);
      if (index > -1) {
        group.episodes.splice(index, 1);

        group.selectedEpisodesCount--;
      }
    }

  }

  //returns the count of selected episodes
  getSelectedCount(seasons: any[]): number {

    var selectedCount = 0;

    seasons.forEach(season => {
      season.episodes.forEach(episode => {
        if (episode.selected) {
          selectedCount++;
        }
      })
    })

    return selectedCount;
  }

  compareWith(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }


  // toggleSeasonsAndEpisodes(member: PartnerGroupMember) {
  //   member.isToggled = !member.isToggled;
  // }

  /**
   * Determines if the partner group has all displayed episodes
   * for the season selected
   * @param season 
   * @param episodes 
   * @returns 
   */
  isGroupSeason(season: Season, episodes: Episode[]): boolean {
    var containsAll = true;

    season.episodes.forEach(episode => {
      if (!episodes.includes(episode)) {
        containsAll = false;
      }
    })

    return containsAll;
  }


  /**
   * Determines if the partner has the episode selected
   * @param episode 
   * @param episodes 
   * @returns 
   */
  isGroupEpisode(episode: Episode, episodes: Episode[]): boolean {
    if (episodes.some(ep => ep.id == episode.id)) {
      episode.selected = true;
    }
    else {
      episode.selected = false;
    }

    return episode.selected;
  }

  /**
   * Sorts the seasons.  
   * Only returns seasons where recognized episodes are available
   * @param pro 
   * @returns 
   */
  getSortedSeasons(pro: any, group: PartnerGroup): any[] {

    //this will be our return value
    let returnValues = [];

    //start by sorting the known seasons for the show
    let seasons = pro.mapToShow.seasons.sort((a, b) => a.seasonNumber - b.seasonNumber);

    //loop through each season and make sure we have recognized episodes to display
    seasons.forEach(season => {
      let episodes = this.getEpisodesForSeason(pro, season, group);

      if (episodes.length > 0) {

        //only include seasons that have recognized episodes to display
        returnValues.push(season);
      }
    })

    return returnValues;
  }

  /**
   * Sorts the episodes extracted from the PRO by season
   * Any unrecognized episode names or episodes without an
   * associated season will be placed at the top of the list.
   * The user will be required to resolve these descrepencies
   * before being able to continue.
   * @param season 
   */
  getEpisodesForSeason(pro: PartnerPro, season: Season, group: PartnerGroup): any[] {

    let returnValues = [];

    //start by pulling all of the extracted episodes for the show
    let extractedEpisodes = this.showsAndEpisodes.find(item => item.name == pro.mapToShow.name || item.name == pro.unrecognizedShow); //using find instead of filter - there should only be 1 match

    if (extractedEpisodes && extractedEpisodes.episodes.length > 0) {

      extractedEpisodes.episodes.forEach(episode => {
        //if the episode name is recognized, return it.
        //Otherwise, it will be grouped with the ungrecognized episode names
        let matchedEpisode = season.episodes.find(item => item.name == episode);

        //now let's check our mapped episodes
        if (this.mappedEpisodes.some(item => item.mapped_from == episode && item.episode.season_id == season.id)) { //NEED TO CHECK WHICH SEASON HERE
          //we have a match, assign that value to matchedEpisode
          let matchedItem = this.mappedEpisodes.find(item => item.mapped_from == episode);
          matchedEpisode = matchedItem ? matchedItem.episode : null;
        }

        //next, we need to check if the episode has been selected for any other partner group

        if (matchedEpisode) {

          for (let i = 0; i < this.partnerGroups.length; i++) {
            const grp = this.partnerGroups[i];

            if (grp.id != group.id) {
              //check to see if the episode has been assigned to another group, if so, set matched to null
              // for (let i = 0; i < grp.members.length; i++) {
              //   const member = grp.members[i];

              // Check if any episode in the member's episodes matches the matchedEpisode ID
              if (grp.episodes.some(ep => ep?.id === matchedEpisode?.id)) {
                // If a match is found, set matchedEpisode to null
                matchedEpisode = null;

                // Exit the loop early
                break;
              }
              // }
            }
          }
        }


        if (matchedEpisode) {
          //set selected to false
          matchedEpisode.selected = this.isGroupEpisode(matchedEpisode, group.episodes)

          returnValues.push(matchedEpisode);
        }
      });
    }

    //return episodes in order
    return returnValues.sort((a, b) => a.episode_number - b.episode_number);

  }

  /**
   * Returns a list of all of the unrecognized episode names
   * These will require intervention by the user in order to
   * assign to a partner
   * @param pro 
   */
  getUnrecognizedEpisodes(pro: PartnerPro) {

    let returnValues = [];

    // let mappedEpisodes = [];

    //start by pulling all of the extracted episodes for the show
    let extractedEpisodes = this.showsAndEpisodes.find(item => item.name == pro.mapToShow.name || item.name == pro.unrecognizedShow); //using find instead of filter - there should only be 1 match

    var matchedEpisode;

    if (extractedEpisodes && extractedEpisodes.episodes.length > 0) {

      for (const episodeName of extractedEpisodes.episodes) {

        for (const season of pro.mapToShow.seasons) {

          //if the episode name is unrecognized, return it.
          //Otherwise, it should have already been returned with it's associated season
          matchedEpisode = season.episodes.find(item => item.name == episodeName);

          if (matchedEpisode) {
            break;
          }

        };

        if (!matchedEpisode) {
          //we still don't have a match, check to see if there is any mapping for this unrecognized episode name
          if (this.mappedEpisodes.some(item => item.mapped_from == episodeName)) {
            //this has already been mapped, don't include it in the unrecognized show names list
            //the mapped to episode will be included in the available episodes list (set up in a different method)
            const matchedItem = this.mappedEpisodes.find(item => item.mapped_from === episodeName);
            matchedEpisode = matchedItem ? matchedItem.episode : null;
          }

        }


        if (episodeName && !matchedEpisode && !returnValues.includes(episodeName)) {
          returnValues.push(episodeName);
        }
      };
    }

    return returnValues;
  }


  /**
   * Opens modal where an unrecognized episode name can be mapped to a recognized episode
   * This may also be the creation of the episode in the database.  The name of the unrecognized 
   * episode name to the stored episode name will also be mapped for future auto mapping
   * @param episodeName 
   */
  mapEpisode(show: Show, episodeName: string) {

    const dialogRef = this.dialog.open(EpisodeMapperModalComponent, {
      // width: '800px',
      // height: '400px',
      data: { unrecognizedEpisodeName: episodeName, show: show } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

      //update the show data
      this.partnerService.getShow(show.id).subscribe(resShow => {
        //update the mapToShow on all items in the mappedPartnerPros array
        this.mappedPartnerPros.forEach(pro => {

          if (pro.mapToShow?.id == resShow.id) {
            pro.mapToShow = resShow;

            //updates options is select box in real time
            this.getMappedEpisodes(pro.mapToShow);
          }
        })


      })
    });
  }


  /**
   * Used to prevent displaying [object object]
   * @param show 
   * @returns 
   */
  getShowDisplayValue(show: any): string {
    // if (show && show?.name) {
    //   return show.name;
    // }
    // else {
    //   return '';
    // }
    if (show && show?.title) {
      return show.title;
    }
    else {
      return '';
    }
  }


  /**
   * When a select box for assigning episodes to a partner is clicked,
   * this method will retrieve all the mapped episodes for the selected show
   * @param show 
   */
  getMappedEpisodes(show: Show) {
    this.importService.getMappedEpisodesForShow(show.id).subscribe(
      (resMappedEpisodes) => {
        this.mappedEpisodes = resMappedEpisodes;
      },
      (error) => {
        //handle error
      })
  }


  /**
   * Tracks changes on the show mapper
   */
  updateShowMapperProfileProgress() {
    let partnerGroupMappedShows: PartnerGroupMappedShow[] = [];

    this.partnerGroups.forEach(group => {

    })

    // this.showMapperProfile.par
  }

  openCreatePROShowModal(showName: string) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: showName,
      partnerGroups: this.partnerGroups,
    };
    this.dialog.open(DataManagementCreateShowModalComponent, dialogConfig);
  }

  changePage(event: any) {
    console.log(event);
    this.currentPage = event.pageIndex + 1;
    this.importService.getImportDetails(this.importProMappedHeadersProfile.id, this.currentPage).subscribe((resPartnerPros: any) => {
      this.allPartnerPros = resPartnerPros.results;
      this.allShowsCount = resPartnerPros.count;

      //extract episodes from imported data
      this.extractEpisodes();

      // Order by partnerPro.show.id ascending
      // const orderedPartnerPros = resPartnerPros.sort((a, b) => a.show.id - b.show.id);

      const orderedPartnerPros = resPartnerPros.results.sort((a, b) => {
        if (a.show === null && b.show !== null) {
          return -1; // Place `a` before `b`
        } else if (a.show !== null && b.show === null) {
          return 1; // Place `b` before `a`
        } else if (a.show === null && b.show === null) {
          // Both are null, sort by `unrecognizedShow`
          return (a.unrecognizedShow || '').localeCompare(b.unrecognizedShow || '');
        } else {
          // Both are not null, sort by `show.id`
          return a.show.id - b.show.id;
        }
      });

      //track all shows
      this.partnerService.allShows$.subscribe((x) => {
        this.allShows = x;


        // //filter down to distinct values - place unrecognized show names at the top
        // const distinctNames = new Set();
        // this.filteredPartnerPros = orderedPartnerPros.filter(partnerPro => {
        //   if (!distinctNames.has(partnerPro.show.name)) {
        //     distinctNames.add(partnerPro.show.name);
        //     return true;
        //   }
        //   return false;
        // }).sort((a, b) => {
        //   const aInAllShows = this.allShows.some(item => item.name === a.show.name);
        //   const bInAllShows = this.allShows.some(item => item.name === b.show.name);

        //   if (aInAllShows && !bInAllShows) {
        //     return 1;  // a should come after b
        //   } else if (!aInAllShows && bInAllShows) {
        //     return -1; // a should come before b
        //   }
        //   return 0;    // no change in order
        // });

        const distinctValues = new Set();
        this.filteredPartnerPros = orderedPartnerPros.filter(partnerPro => {
          // valueToCheck ???
          // partnerPro.show & show.name are always returning as null?
          // const valueToCheck = partnerPro.show ? partnerPro.show.name : partnerPro.unrecognizedShow;
          // const valueToCheck = partnerPro.showName ? partnerPro.showName : partnerPro.unrecognizedShow;
          const valueToCheck = partnerPro.showName;

          if (!distinctValues.has(valueToCheck)) {
            distinctValues.add(valueToCheck);
            return true;
          }
          return false;
        }).sort((a, b) => {
          const aInAllShows = this.allShows.some(item => item.name === (a.show ? a.show.name : a.unrecognizedShow));
          const bInAllShows = this.allShows.some(item => item.name === (b.show ? b.show.name : b.unrecognizedShow));

          if (aInAllShows && !bInAllShows) {
            return 1;  // a should come after b
          } else if (!aInAllShows && bInAllShows) {
            return -1; // a should come before b
          }

          // If both are either in or not in allShows, maintain their order
          return 0;
        });


        this.importService.setMappedParterPros(this.filteredPartnerPros);

      });

      // //build the list for this display
      // //this will have dynamic properties set from the html file
      // this.mappedPartnerPros = this.filteredPartnerPros;  });
    });
  }

  searchShowsByTitleNetwork() {
    console.log('keyValue: ', this.keyValue);
    // this is clearly not DRY 
    if (this.isSearchingShows == false) {
      this.isSearchingShows = true;
      if (this.currentPage == 0) {
        this.importService.getImportDetails(this.importProMappedHeadersProfile.id, this.currentPage + 1, this.keyValue, 'network').subscribe((resPartnerPros: any) => {
          this.allPartnerPros = resPartnerPros.results;
          this.allShowsCount = resPartnerPros.count;
    
          //extract episodes from imported data
          this.extractEpisodes();
    
          // Order by partnerPro.show.id ascending
          // const orderedPartnerPros = resPartnerPros.sort((a, b) => a.show.id - b.show.id);
    
          const orderedPartnerPros = resPartnerPros.results.sort((a, b) => {
            if (a.show === null && b.show !== null) {
              return -1; // Place `a` before `b`
            } else if (a.show !== null && b.show === null) {
              return 1; // Place `b` before `a`
            } else if (a.show === null && b.show === null) {
              // Both are null, sort by `unrecognizedShow`
              return (a.unrecognizedShow || '').localeCompare(b.unrecognizedShow || '');
            } else {
              // Both are not null, sort by `show.id`
              return a.show.id - b.show.id;
            }
          });
    
          //track all shows
          this.partnerService.allShows$.subscribe((x) => {
            this.allShows = x;
    
    
            // //filter down to distinct values - place unrecognized show names at the top
            // const distinctNames = new Set();
            // this.filteredPartnerPros = orderedPartnerPros.filter(partnerPro => {
            //   if (!distinctNames.has(partnerPro.show.name)) {
            //     distinctNames.add(partnerPro.show.name);
            //     return true;
            //   }
            //   return false;
            // }).sort((a, b) => {
            //   const aInAllShows = this.allShows.some(item => item.name === a.show.name);
            //   const bInAllShows = this.allShows.some(item => item.name === b.show.name);
    
            //   if (aInAllShows && !bInAllShows) {
            //     return 1;  // a should come after b
            //   } else if (!aInAllShows && bInAllShows) {
            //     return -1; // a should come before b
            //   }
            //   return 0;    // no change in order
            // });
    
            const distinctValues = new Set();
            this.filteredPartnerPros = orderedPartnerPros.filter(partnerPro => {
              // valueToCheck ???
              // partnerPro.show & show.name are always returning as null?
              // const valueToCheck = partnerPro.show ? partnerPro.show.name : partnerPro.unrecognizedShow;
              // const valueToCheck = partnerPro.showName ? partnerPro.showName : partnerPro.unrecognizedShow;
              const valueToCheck = partnerPro.showName;
    
              if (!distinctValues.has(valueToCheck)) {
                distinctValues.add(valueToCheck);
                return true;
              }
              return false;
            }).sort((a, b) => {
              const aInAllShows = this.allShows.some(item => item.name === (a.show ? a.show.name : a.unrecognizedShow));
              const bInAllShows = this.allShows.some(item => item.name === (b.show ? b.show.name : b.unrecognizedShow));
    
              if (aInAllShows && !bInAllShows) {
                return 1;  // a should come after b
              } else if (!aInAllShows && bInAllShows) {
                return -1; // a should come before b
              }
    
              // If both are either in or not in allShows, maintain their order
              return 0;
            });
    
    
            this.importService.setMappedParterPros(this.filteredPartnerPros);
    
          });
    
          // //build the list for this display
          // //this will have dynamic properties set from the html file
          // this.mappedPartnerPros = this.filteredPartnerPros;  });
          this.isSearchingShows = false;
        });
      } else {
        this.importService.getImportDetails(this.importProMappedHeadersProfile.id, this.currentPage, this.keyValue, 'network').subscribe((resPartnerPros: any) => {
          this.allPartnerPros = resPartnerPros.results;
          this.allShowsCount = resPartnerPros.count;
    
          //extract episodes from imported data
          this.extractEpisodes();
    
          // Order by partnerPro.show.id ascending
          // const orderedPartnerPros = resPartnerPros.sort((a, b) => a.show.id - b.show.id);
    
          const orderedPartnerPros = resPartnerPros.results.sort((a, b) => {
            if (a.show === null && b.show !== null) {
              return -1; // Place `a` before `b`
            } else if (a.show !== null && b.show === null) {
              return 1; // Place `b` before `a`
            } else if (a.show === null && b.show === null) {
              // Both are null, sort by `unrecognizedShow`
              return (a.unrecognizedShow || '').localeCompare(b.unrecognizedShow || '');
            } else {
              // Both are not null, sort by `show.id`
              return a.show.id - b.show.id;
            }
          });
    
          //track all shows
          this.partnerService.allShows$.subscribe((x) => {
            this.allShows = x;
    
    
            // //filter down to distinct values - place unrecognized show names at the top
            // const distinctNames = new Set();
            // this.filteredPartnerPros = orderedPartnerPros.filter(partnerPro => {
            //   if (!distinctNames.has(partnerPro.show.name)) {
            //     distinctNames.add(partnerPro.show.name);
            //     return true;
            //   }
            //   return false;
            // }).sort((a, b) => {
            //   const aInAllShows = this.allShows.some(item => item.name === a.show.name);
            //   const bInAllShows = this.allShows.some(item => item.name === b.show.name);
    
            //   if (aInAllShows && !bInAllShows) {
            //     return 1;  // a should come after b
            //   } else if (!aInAllShows && bInAllShows) {
            //     return -1; // a should come before b
            //   }
            //   return 0;    // no change in order
            // });
    
            const distinctValues = new Set();
            this.filteredPartnerPros = orderedPartnerPros.filter(partnerPro => {
              // valueToCheck ???
              // partnerPro.show & show.name are always returning as null?
              // const valueToCheck = partnerPro.show ? partnerPro.show.name : partnerPro.unrecognizedShow;
              // const valueToCheck = partnerPro.showName ? partnerPro.showName : partnerPro.unrecognizedShow;
              const valueToCheck = partnerPro.showName;
    
              if (!distinctValues.has(valueToCheck)) {
                distinctValues.add(valueToCheck);
                return true;
              }
              return false;
            }).sort((a, b) => {
              const aInAllShows = this.allShows.some(item => item.name === (a.show ? a.show.name : a.unrecognizedShow));
              const bInAllShows = this.allShows.some(item => item.name === (b.show ? b.show.name : b.unrecognizedShow));
    
              if (aInAllShows && !bInAllShows) {
                return 1;  // a should come after b
              } else if (!aInAllShows && bInAllShows) {
                return -1; // a should come before b
              }
    
              // If both are either in or not in allShows, maintain their order
              return 0;
            });
    
    
            this.importService.setMappedParterPros(this.filteredPartnerPros);
    
          });
    
          // //build the list for this display
          // //this will have dynamic properties set from the html file
          // this.mappedPartnerPros = this.filteredPartnerPros;  });
          this.isSearchingShows = false;
        });
      }
    }
  }
  getSearchVal(event: any){
    this.keyValue = event.trim();
  }
}
